import React from "react";
import "./Appearance.css";
import useAppearance from "./hooks/useAppearance";

import AppearanceDropdown from "./components/AppearanceDropdown";

const Appearance = () => {
  const appearance = useAppearance();

  return (
    <AppearanceDropdown
      {...appearance}
    />
  );
};

export default Appearance;